var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefence(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 48,
    height: 48,
    rx: 24,
    fill: "#0D6CF9",
    fillOpacity: 0.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 48,
    height: 48,
    rx: 24,
    stroke: "#0D6CF9",
    strokeOpacity: 0.3,
    strokeWidth: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.302 37.6152C27.5234 37.7444 27.6341 37.809 27.7903 37.8425C27.9116 37.8685 28.0884 37.8685 28.2097 37.8425C28.3659 37.809 28.4766 37.7444 28.698 37.6152C30.646 36.4788 36 32.9088 36 28.0004V23.218C36 22.4184 36 22.0187 35.8692 21.6751C35.7537 21.3715 35.566 21.1006 35.3223 20.8859C35.0465 20.6428 34.6722 20.5024 33.9236 20.2217L28.5618 18.211C28.3539 18.1331 28.25 18.0941 28.143 18.0786C28.0482 18.0649 27.9518 18.0649 27.857 18.0786C27.75 18.0941 27.6461 18.1331 27.4382 18.211L22.0764 20.2217C21.3278 20.5024 20.9535 20.6428 20.6777 20.8859C20.434 21.1006 20.2463 21.3715 20.1308 21.6751C20 22.0187 20 22.4184 20 23.218V28.0004C20 32.9088 25.354 36.4788 27.302 37.6152Z",
    stroke: "#0D6CF9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefence);
export default __webpack_public_path__ + "static/media/defence.b4cba38bf262d039fd3be3274777221e.svg";
export { ForwardRef as ReactComponent };